

























































import { Vue, Component, Prop } from "vue-property-decorator";

import CopyAddressButton from "@/views/components/CopyAddressButton.vue";
import SelectDefaultHub from "@/views/components/SelectDefaultHub.vue";
import {namespace} from "vuex-class";

const hubsModule = namespace("hubs");

@Component({
  name: "ExternalShipment",
  components: {
    CopyAddressButton,
    SelectDefaultHub,
  },
})
export default class ExternalShipment extends Vue {
  private isMaps: boolean = false;
  private addressIsSelected: boolean = false;

  @hubsModule.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  private close() {
    this.$emit("dialog:clickClose");
  }

  private showMaps() {
    this.isMaps = true;
  }

  private hideMaps(addressIsSelected: boolean = false) {
    this.addressIsSelected = addressIsSelected;
    this.isMaps = false;
  }
}
